/** Preselect LTR when the range first becomes ≥ 30 days; keep an explicit uncheck. */
export function nextLongTermSearchValue(params: {
  eligible: boolean;
  wasEligible: boolean;
  currentLongTerm: boolean;
  blocked: boolean;
}): boolean {
  if (params.blocked || !params.eligible) {
    return false;
  }
  return params.wasEligible ? params.currentLongTerm : true;
}
